
import { getData, postData, putData, deleteData } from "../apiClient";

/**
 * FoodType API Client
 * Handles all network requests related to Food Types (CRUD operations).
 */
const ItemName = "Food Type";
const API_URL = "food-type";

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error(`Get ${ItemName} with pagination API error:`, error);
        return {
            success: false,
            ...error,
        };
    }
};

// get item data with id
export const GetById = async (id) => {
    try {
        const result = await getData(`/${API_URL}/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get  ${ItemName} data API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const GetUserWebInfoByid = async (id) => {
    try {
        const result = await getData(`/${API_URL}/userwebinfo/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get  ${ItemName} data API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};
// create item ** // Updated Api Error Handle Method
export const Create = async ({ data }) => {
    try {
        const result = await postData(`/${API_URL}/`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Create ${ItemName} API error:`, error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// update item ** // Updated Api Error Handle Method
export const Update = async ({ id, data }) => {
    try {
        const result = await putData(`/${API_URL}/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Update ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete item
export const Delete = async ({ id }) => {
    try {
        const result = await deleteData(`/${API_URL}/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Delete ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

